<template>
  <v-dialog :retain-focus="false" :value="sectionEditor.show" :width="1000" @input="handleClosePopup">
    <div style="background-color: #fff">
      <div class="header-modal">
        <v-card-title class="d-flex justify-space-between align-center" style="padding: 10px 0">
          <span style="color: #0081c7">{{ fields.title }}</span>
          <v-btn icon @click="handleClosePopup">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
      </div>
      <v-card-text class="pa-4" style="max-height: 70vh; overflow-y: auto">
        <div class="mb-4">
          <label class="label-input">Section</label
          ><v-row
            ><v-col cols="12" md="8"><v-text-field v-model="fields.title" label="Name" hide-details/></v-col
            ><v-col cols="12" md="4"
              ><v-checkbox v-model="fields.enableAnchor" label="Enable Anchor" hide-details/></v-col
          ></v-row>
        </div>
        <SectionSettingsContainerFuild
          class="mb-4"
          :settings="fields.settings"
          :container-page="fields.containerPage"
          :use-background-mobile="true"
          :show-container-page="false"
        />
        <div class="mb-4">
          <label class="label-input">Tags</label>
          <div class="group-item">
            <v-row
              ><v-col cols="12" md="6"
                ><v-text-field v-model="fields.tags.deepGloss" label="Deep Gloss" hide-details/></v-col
              ><v-col cols="12" md="6"><v-text-field v-model="fields.tags.ceramic" label="Ceramic" hide-details/></v-col
            ></v-row>
          </div>
        </div>
        <div class="mb-4">
          <label class="label-input">Content</label>
          <ckeditor :editor="editor" v-model="fields.content.headline" :config="editorConfig" />
        </div>
        <ButtonPrimary :button="fields.button" />
      </v-card-text>
      <div class="footer-modal">
        <v-card-actions
          ><v-spacer /><v-btn min-width="100" depressed @click="handleClosePopup">Cancel</v-btn
          ><v-btn min-width="100" color="primary" @click="handleSave">Save</v-btn></v-card-actions
        >
      </div>
    </div>
  </v-dialog>
</template>

<script>
import { ckeditorConfigFullToolbar } from '@/helpers/editor';
import Editor from 'ckeditor5-custom-build/build/ckeditor';
import { updateHtmlFromData } from '../common/html/update.js';
import ButtonPrimary from './common/button-primary.vue';
import SectionSettingsContainerFuild from './common/section-settings-container-fuild.vue';

export default {
  name: 'FurnitureshopBanner',
  components: { ButtonPrimary, SectionSettingsContainerFuild },
  props: { sectionEditor: { type: Object, required: true } },
  data() {
    return {
      editor: Editor,
      editorConfig: ckeditorConfigFullToolbar,
      fields: {
        title: 'Furnitureshop banner',
        enableAnchor: false,
        settings: {
          paddingTop: false,
          paddingBottom: false,
          backgroundColor: '#050505',
          textColor: '#ffffff',
          overlayColor: '#000000',
          overlayOpacity: 0,
          showOverlay: false,
          backgroundImage: '',
          useBackgroundMobile: true,
          backgroundImageMobile: '',
        },
        containerPage: { enableStyle: false, background: '#FFFFFF' },
        tags: { deepGloss: '', ceramic: '' },
        content: {
          headline: '',
        },
        button: {
          show: true,
          backgroundColor: '#FF8100',
          color: '#FFFFFF',
          radius: 3,
          text: 'Buy now',
          link: '#',
          iconPrefix: { show: false, src: '' },
          iconSuffix: {
            show: true,
            src: '',
          },
          subBtn: { show: true, text: '🏆 Buy 5 Get 5 Free (10 Kits)' },
        },
      },
    };
  },
  mounted() {
    this.applyExtract(this.sectionEditor.sectionExtract);
  },
  watch: {
    sectionEditor: {
      handler(value) {
        if (value && value.sectionExtract) this.applyExtract(value.sectionExtract);
      },
      deep: true,
    },
  },
  methods: {
    applyExtract(extract) {
      if (!extract) return;
      this.fields = {
        ...this.fields,
        ...extract,
        settings: { ...this.fields.settings, ...(extract.settings || {}) },
        containerPage: { ...this.fields.containerPage, ...(extract.containerPage || {}) },
        tags: { ...this.fields.tags, ...(extract.tags || {}) },
        content: { ...this.fields.content, ...(extract.content || {}) },
        button: {
          ...this.fields.button,
          ...(extract.button || {}),
          iconPrefix: { ...this.fields.button.iconPrefix, ...((extract.button || {}).iconPrefix || {}) },
          iconSuffix: { ...this.fields.button.iconSuffix, ...((extract.button || {}).iconSuffix || {}) },
          subBtn: { ...this.fields.button.subBtn, ...((extract.button || {}).subBtn || {}) },
        },
      };
    },
    handleClosePopup() {
      this.$emit('close');
    },
    handleSave() {
      const html = updateHtmlFromData.sectionFurnitureshopBanner(this.sectionEditor.section.html, this.fields);
      this.$emit('update:section', { ...this.sectionEditor.section, title: this.fields.title, html });
      this.$emit('close');
    },
  },
};
</script>
